module.exports = __webpack_public_path__ + "static/media/developmentDocumentation.27ca8270.yaml";